import { Link } from "@mui/material";

const ConfirmationLabel = () => {
  return (
    <>
      {" "}
      Отправляя форму, я даю{" "}
      <Link
        href='https://disk.yandex.ru/i/WejnKwPQalJGKw'
        target='_blank'>
        согласие
      </Link>{" "}
      на обработку персональных данных, а также выражаю согласие с{" "}
      <Link
        href='https://disk.yandex.ru/i/dqQXePdOmagPKA'
        target='_blank'>
        пользовательским соглашением
      </Link>{" "}
      и{" "}
      <Link
        href='https://disk.yandex.ru/i/Nej6ZnHNDOOi2Q'
        target='_blank'
        rel='noreferrer'>
        лицензионным соглашением
      </Link>
    </>
  );
};

export default ConfirmationLabel;
